export const guardianTableItemFields = {
    id: 'id',
    firstName: 'firstName',
    lastName: 'lastName',
    idNumber: 'idNumber',
    phoneNumber: 'phoneNumber',
} as const;
